import { Book } from './Book'
import { Menu } from './Menu'
import { Politics } from './Politics'

export const Modal = { Menu, Book, Politics }
